import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-no-check-setting",
  "use": "ico-no-check-setting-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"ico-no-check-setting\">\n  <g id=\"ico-no-check-setting_Ellipse_176\" data-name=\"Ellipse 176\" fill=\"none\" stroke=\"#737878\" stroke-width=\"2\">\n    <circle cx=\"14\" cy=\"14\" r=\"14\" stroke=\"none\" />\n    <circle cx=\"14\" cy=\"14\" r=\"13\" fill=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol